export default {
  name: 'video-player',
  ui: {
    iframe: '[js-video-player-iframe]',
    video: '[js-video-player-video]',
    overlay: '[js-video-player-overlay]',
  },
  events: [
    {
      on: 'click',
      target: 'overlay',
      handle () {
        this.ui.overlay.classList.add('is-hidden')
        this.ui.video.play()
      },
    },
  ],
  componentDidMount () {
  },
}
